<ng-template [ngIf]="brandImg">
  <a [routerLink]="routerLink">
    <img *ngIf="brandFull"
         [cHtmlAttr]="brandFull"
         [ngClass]="'sidebar-brand-full'">
    <img *ngIf="brandNarrow"
         [cHtmlAttr]="brandNarrow"
         [ngClass]="'sidebar-brand-narrow'">
  </a>
</ng-template>
<ng-template [ngIf]="!brandImg">
  <ng-content></ng-content>
</ng-template>
